import { ICrosswordApiEntity } from 'data/Api/Crossword';
import type { DatabaseTableType } from '../Database.types';

export const CROSSWORD_COLUMNS = '++id, sourceData';

export type TCrosswordTable = DatabaseTableType & ICrosswordApiEntity;
